module.exports = __webpack_public_path__ + "lk.svg?f8d21a6b463aa47f76f4eaaa36497fca";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/lk.svg
// module id = 1213
// module chunks = 0